import { render, staticRenderFns } from "./opertion.vue?vue&type=template&id=659b2886&scoped=true"
import script from "./opertion.vue?vue&type=script&lang=ts"
export * from "./opertion.vue?vue&type=script&lang=ts"
import style0 from "./opertion.vue?vue&type=style&index=0&id=659b2886&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659b2886",
  null
  
)

export default component.exports